import { passwordSet as passwordSetApi } from "../../../apiCalls/caller";
import { setUserData } from "../../../utils/StorageManager";

import {
  setPasswordSuccess,
  apiError,
  reset_set_password_flag,
} from "./reducer";

export const passwordSet = (user, history) => async (dispatch) => {
  try {
    let response = await passwordSetApi(user);
    
    // Handle wrapped response (response.value)
    const actualResponse = response.value || response;
    
    if (actualResponse.success) {
      // Check if it's a redirect response (like login does)
      if (actualResponse.message !== "Redirect") {
        setUserData(actualResponse.data, false);
        const redirectURL = localStorage.getItem("postLoginRedirect");
        if (redirectURL) {
          history(redirectURL);
          localStorage.removeItem("postLoginRedirect");
        } else if (actualResponse.data?.user_freeType === "trial") {
          history("/trial-welcome");
        } else {
          history("/products");
        }
      } else {
        window.location.href = actualResponse.data;
      }
      
      dispatch(setPasswordSuccess(actualResponse));
    } else {
      dispatch(apiError(actualResponse));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetSetPasswordFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_set_password_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
